import React, { CSSProperties, HTMLAttributeAnchorTarget } from 'react';
import Icon, { Icons } from './icon/Icon';
import Link from 'next/link';

export interface LinkButtonProps {
	href: string;
	children: React.ReactNode;
	onClick?: () => void;
	variant?: 'primary' | 'secondary' | 'ghost-inverted' | 'inverted';
	size?: 'small' | 'medium' | 'large';
	icon?: Icons;
	target?: HTMLAttributeAnchorTarget;
	className?: string;
	style?: CSSProperties;
}

export const LinkButton = ({
	variant = 'secondary',
	size = 'medium',
	icon,
	children,
	href,
	className,
	...props
}: LinkButtonProps) => {
	const mode = `kkd-button--${variant}`;
	const hasIcon = icon ? 'flex items-center' : 'inline-block';

	const getIconColor = () => {
		if (variant === 'primary') return 'white';
		if (variant === 'inverted') return 'red';
		if (variant === 'ghost-inverted') return ' white';
		return 'text-black-500';
	};

	return (
		<Link
			href={href || '/'}
			className={[hasIcon, 'kkd-button', `kkd-button--${size}`, `${className}`, mode].join(' ')}
			{...props}
		>
			<span className={icon ? 'inline-block mr-3' : ''}>{children}</span>
			{icon && (
				<Icon icon={icon} color={getIconColor()} size={size === 'small' ? 16 : 18} className="inline-block" />
			)}
		</Link>
	);
};
